var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Container as MuiContainer, makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
    root: ({ pt, pr, pb, pl, scrollableY, disableScrollbar }) => ({
        height: scrollableY ? "100%" : "auto",
        paddingTop: theme.spacing(pt),
        paddingBottom: theme.spacing(pb),
        paddingRight: theme.spacing(pr),
        paddingLeft: theme.spacing(pl),
        overflow: "hidden",
        scrollbarWidth: disableScrollbar ? "none" : "initial",
        overflowY: scrollableY ? "scroll" : "initial",
        "-ms-overflow-style": disableScrollbar ? "none" : "initial",
        "&::-webkit-scrollbar": {
            display: disableScrollbar ? "none" : "initial"
        }
    })
}));
export const Container = (_a) => {
    var { children, scrollableY = false, disableScrollbar = false, pt = 0, pr = 0, pb = 0, pl = 0, maxWidth } = _a, props = __rest(_a, ["children", "scrollableY", "disableScrollbar", "pt", "pr", "pb", "pl", "maxWidth"]);
    const classes = useStyles({
        pt,
        pr,
        pb,
        pl,
        scrollableY,
        disableScrollbar
    });
    return (React.createElement(MuiContainer, Object.assign({ disableGutters: true, maxWidth: maxWidth, classes: { root: classes.root } }, props), children));
};
//# sourceMappingURL=Container.js.map